import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { businessBuilderAttemptBackend } from './business-builder-attempt.backend';
import { businessBuilderAttemptReducer } from './business-builder-attempt.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'businessBuilderAttempt',
      businessBuilderAttemptReducer,
    ),
    BackendModule.forFeature(
      'businessBuilderAttempt',
      businessBuilderAttemptBackend,
    ),
  ],
})
export class DatastoreBusinessBuilderAttemptModule {}
